import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import AddLineGroup from './AddLineGroup';
import Introduction from './Introduction';
import ApiGo_TS from '../../../actions/ApiGo_TS';
import { useAppSelector } from '../../../stores/hooks';
import Mos from '../../../actions/Mos';
import { DF } from '../../dashboard/DashFunction';

const LineChannel =(props)=>{
    const mos = Mos()
    const bed_map = mos?.line_notify_bed_map
    const {t} = useTranslation()
    // Line set
    const [lineGroup, setLineGroup] = useState(false);
    const [existLineGroup, setExistLineGroup] = useState([]);
    const store_user = useAppSelector(state=>state.store_users)
    // 彈出權杖登入
    const [aouthInput, setAouthInput] = useState(false);
    const [threeInput, setThreeInput] = useState([]);
    function toggleAouthInput(id=0, role="", email="", title="", token="", post_or_put="POST"){
        setAouthInput(!aouthInput)
        setThreeInput([role, email, title, token, post_or_put, id])
    }
    const [refresh, setRefresh] = useState(false);

    // 彈出教學視窗
    const [popUpShow, setPopUpShow] = useState(false);
    function toggolePopUp(){ setPopUpShow(!popUpShow) }

    // 彈出教學視窗
    const PopUpSign = <Introduction setLineGroup={setLineGroup} lineGroup={lineGroup} hide={toggolePopUp} setAouthInput={setAouthInput}/>
    // const [lineNotifyStart, setLineNotifyStart] = useState(false);
    useEffect(()=>{
        getLineGroup()
        function getLineGroup(){
            ApiGo_TS.getline_token()
            .then(res=>{
                setExistLineGroup(res);
                setRefresh(false)
            })
            .catch(err=>{console.log(err);})
        }
    }, [refresh])
    // function getLineMap(){
    //     mos.sendPayload("get_bed_map", "true")
    // }
    useEffect(()=>{console.log(bed_map)}, [bed_map])
    // useEffect(()=>{
    //     if(!lineNotifyStart){ return }
    //     ApiGo.getLineNotify_start().then(res=>{console.log(res);})
    //     .catch(err=>{console.log(err);})
    // }, [lineNotifyStart])
    return(
    <div className='fx-d-c w-100 h-80 font-ml'>
        {popUpShow? PopUpSign:null}
        {/* <div className='fx-d-r fx-fsc font-m w-40 h-15 margb-xxs bgC-white hig-auto br-20 shadow-s-noHover pad-5 t b pad-30 b'>
            <div className='font-l margl-xxs h-100 margt-xxs fx-ccc'>Line Notify 功能</div>
            <div className='margl-s w-50 h-100 fx-d-r fx-fsc'>
                <div className={` btn_switch_BreathChart lineNot font-m ${lineNotifyStart?"":'on_Click off'}`} onClick={()=>{setLineNotifyStart(!lineNotifyStart)}}></div>
                {lineNotifyStart? <div className='margl-xs'>開啟</div>:<div className='margl-xs'>關閉</div>}
            </div>
        </div> */}
        <div className='fx-d-c bgC-white wid-admin-90 hig-auto br-20 shadow-s-noHover pad-5 t b pad-30 b'>
            <div className='font-l margl-xxs h-100 margt-xxs'>{t("ADMIN.OTHER_PAGE.LINE_GROUP")}</div>
            <div className='fx-d-r wid-admin-90 pad-15 t b'>
                <div className='w-20 margl-xs'>{t("ADMIN.OTHER_PAGE.USER")}</div>
                <div className='w-25 '>{t("ADMIN.OTHER_PAGE.DISCRIPTION")}</div>
                <div className='w-45'>{t("ADMIN.OTHER_PAGE.TOKEN")}</div>
                {/* <div className='w-10 fx-ccc'>{t("ADMIN.NETWORK_SETTING.CONFIG")}</div> */}
                <div className='w-10 fx-ccc'>{t("ADMIN.NETWORK_SETTING.CONFIG")}</div>
                {/* <div className='w-10 fx-ccc'></div> */}
                </div>
            {existLineGroup.map(res=>{
                return(
                    <div className='fx-d-r wid-admin-90 pad-15 t b row_hover' key={res.token}>
                        <div className='w-20 margl-xs'>{DF.abbreviate(store_user.orign_users_array.filter(u=>u.id===parseInt(res.user_id))[0]?.email, 15)}</div>
                        <div className='w-25 '>{res.title}</div>
                        <div className='w-45 font-m'>{res.token}</div>
                        {/* <div className='w-10 fx-ccc'></div> */}
                        <div className='w-10 fx-ccc'>
                            <div className='br-10 bgC-light w-60 shadow-xs fx-ccc cursor pt'
                                onClick={()=>{toggleAouthInput(res.id, res.role, res.email, res.title, res.token, "PUT")}}>修改</div>
                        </div>
                        {/* <div className='w-10 fx-ccc'>
                            <div className='br-10 bgC-alert-EE w-60 shadow-xs fx-ccc cursor pt'
                                onClick={()=>{toggleAouthInput(res.id, res.role, res.email, res.title, res.token, "PUT")}}>刪除</div>
                        </div> */}
                    </div>
                )}
            )}
        </div>
        {/* <div>
            <div>取得line 配對 map</div>
            <div onClick={getLineMap} className='bgC-alert-E br-20 w-50 shadow-xs fx-ccc margl-xs cursor pt'>123</div>
        </div> */}
        {/* part 1. 有沒有權杖 */}
        <div className='fx-d-r w-100 margt-xs'>
        <div className='font-l fx-d-c'>{t("ADMIN.OTHER_PAGE.CREATE_NEW_GROUP")}</div>
            <div className='w-50 fx-d-r margl-s'>
            <div onClick={()=>{toggleAouthInput()}} className='bgLG br-20 w-50 shadow-xs fx-ccc cursor pt'>{t("ADMIN.OTHER_PAGE.I_WANT_TO_CREATE_NEW_GROUP")}</div>
            <div onClick={toggolePopUp} className='bgC-alert-E br-20 w-50 shadow-xs fx-ccc margl-xs cursor pt'>{t("ADMIN.OTHER_PAGE.I_DONT_KNOW_HOW_TO_CREATE_NEW_GROUP")}</div>
            </div>
        </div>
        {aouthInput? <AddLineGroup hide={toggleAouthInput} result={threeInput} setRefresh={setRefresh} />:null}
    </div>
    );

}
export default LineChannel;